import dayjs from 'dayjs'

const NAIRA = new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' })

/** Kobo (integer) to "₦1,234.50". */
export const naira = (kobo) => (kobo === null || kobo === undefined || kobo === '' ? '—' : NAIRA.format(Number(kobo) / 100))

/** User-typed naira (e.g. "12,500.50") to integer kobo. Returns NaN for junk. */
export const toKobo = (value) => {
  const clean = String(value ?? '').replace(/[,\s₦]/g, '')
  if (!/^\d+(\.\d{1,2})?$/.test(clean)) return NaN
  return Math.round(Number(clean) * 100)
}

export const formatDate = (v) => (v ? dayjs(v).format('D MMM YYYY') : '—')
export const formatDateTime = (v) => (v ? dayjs(v).format('D MMM YYYY, HH:mm') : '—')

/** "•••••••1234" for an ID that is only ever known by its last four digits. */
export const maskedId = (last4) => (last4 ? `•••••••${last4}` : '—')

/** "+2348031234567" to "0803 123 4567". */
export const displayPhone = (p) => {
  if (!p) return '—'
  const m = /^\+234(\d{3})(\d{3})(\d{4})$/.exec(p)
  return m ? `0${m[1]} ${m[2]} ${m[3]}` : p
}

export const fullName = (c) => (c ? `${c.first_name} ${c.last_name}` : '')
